import { render, staticRenderFns } from "./RealEstateItemEdit.vue?vue&type=template&id=5ce8434a&scoped=true&"
import script from "./RealEstateItemEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateItemEdit.vue?vue&type=style&index=0&id=5ce8434a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce8434a",
  null
  
)

export default component.exports